module.exports = __webpack_public_path__ + "img/banner-8.973a78b4.jpg";